//we make the assumption that user cannot debounce, multi-task on more than debounce-able element at a time, and debounce time is short
let timeoutID: any = null;
export function debounce(fn: () => void, delay: number): (...args: any) => void {
	return function(...args: any) {
		clearTimeout(timeoutID);
		timeoutID = setTimeout(() => {
			// eslint-disable-next-line
			// @ts-ignore
			fn.apply(this, args);
		}, delay);
	};
}
